import React from 'react';
import { LayersIcon } from './Icons';

interface EmptyStateProps {
  title: string;
  message: string;
  buttonText: string;
  onButtonClick: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({ title, message, buttonText, onButtonClick }) => {
  return (
    <div className="flex flex-col items-center justify-center text-center p-12 bg-[var(--panel-bg)]/50 border border-dashed border-[var(--border-color)] rounded-xl h-full">
        <div className="w-16 h-16 flex items-center justify-center rounded-full bg-gradient-to-br from-[var(--gradient-from)] to-[var(--gradient-to)] text-white mb-6">
            <LayersIcon />
        </div>
      <h2 className="text-2xl font-bold text-[var(--text-primary)]">{title}</h2>
      <p className="mt-2 max-w-sm text-[var(--text-secondary)]">{message}</p>
      <button 
        onClick={onButtonClick} 
        className="mt-6 px-6 py-3 text-base font-semibold text-white bg-gradient-to-r from-[var(--gradient-from)] to-[var(--gradient-to)] rounded-md hover:opacity-90 transition-opacity"
      >
        {buttonText}
      </button>
    </div>
  );
};

export default EmptyState;